import PublishedDate from "./PublishedDate";

function Article({ element, onClick }) {
  return (
    <div className="col-12 col-sm-6 col-md-4 mb-4 cadre-article pointer imgContainer" onClick={onClick}>
      <img
        src={`${process.env.REACT_APP_ARTICLE_URL}${element?.featured_image_url}`}
        alt={element?.titre}
        className="article-featured "
      />
      <h6 className="grey500 title mt-16 mb-0 mt-16">{element?.titre}</h6>
      <p className="body grey66 mt-8 desc-article mb-0 mt-8 mb-8">
        {element?.description}
      </p>
      <PublishedDate published_at={element?.published_at} />
    </div>
  );
}

export default Article;
